// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import SaveButton from './SaveButton'
import DealdeskModalButton from './DealdeskModalButton'
import DealDeskDiscountCreatorButton from './DealDeskDiscountCreatorButton'
import CloneEinButton from './CloneEinButton'
import BookQuoteButton from './BookQuoteButton'
// Asset Imports
// Bootstrap Imports
import Button from 'react-bootstrap/Button'
import ButtonToolbar from 'react-bootstrap/ButtonToolbar'
import Navbar from 'react-bootstrap/Navbar'
import Container from 'react-bootstrap/Container'
import ToggleButton from 'react-bootstrap/ToggleButton'
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup'
import InputGroup from 'react-bootstrap/InputGroup'

export default function BottomToolbar({
   productPerformanceEECount,
   setProductPerformanceEECount,
   productTestAccount,
   setProductTestAccount,
}) {
   const state = useQuoteContext()
   const { getString } = state
   const permissionsQuoteType =
      state.featurePermissions['SaveAndResetWithQuoteTypePermissions']
   const permissionsSaveButton = state.featurePermissions['SaveButton']
   const permissionsSubmitDealdesk = state.featurePermissions['SubmitDealDesk']
   const permissionsBookQuote = state.featurePermissions['BookQuote']
   const permissionsCloneEINs = state.featurePermissions['CloneEINs']

   const ShowDealdeskButton =
      permissionsSubmitDealdesk?.includes(state.user_role) ?? false
   const ShowSaveButton =
      permissionsSaveButton?.includes(state.user_role) ?? false
   const ShowQuoteTypeSelector =
      permissionsQuoteType?.includes(state.user_role) ?? false
   const ShowBookQuoteButton =
      permissionsBookQuote?.includes(state.user_role) ?? false
   const ShowCloneEINButton =
      (permissionsCloneEINs?.includes(state.user_role) &&
         !state.opportunity_id?.startsWith('ACC-')) ??
      false

   const clear_button_margin = ShowSaveButton ? 'my-0 me-1' : 'my-0 me-5'

   if (state.user_view === 'Internal') {
      const handleChange = (val) => {
         state.setQuoteType(val)
      }
      const justify_class = ShowQuoteTypeSelector
         ? 'mt-4 justify-content-between align-items-center'
         : 'my-4 justify-content-end'
      // Add mt-3 to button container only if CloneEIN button is visible (creates separate row)
      const buttonContainerClass = ShowCloneEINButton
         ? 'd-flex flex-row justify-content-end align-items-center mt-3'
         : 'd-flex flex-row justify-content-end align-items-center'
      // Determine which button is last (rightmost) - needs me-5 to align with Save button below
      // DealDesk and DealDeskDiscount buttons get me-2 spacing, BookQuote is always last with me-5
      const dealdeskMargin = 'my-0 me-2'
      const dealDeskDiscountMargin = 'my-0 me-2'
      const bookQuoteMargin = 'my-0 me-5'
      return (
         <>
            <ButtonToolbar role='toolbar' className={justify_class}>
               {ShowQuoteTypeSelector && (
                  <InputGroup size='md' className='my-0'>
                     <InputGroup.Text size='md'>
                        {getString(
                           'product.BottomToolbar.ButtonToolbar.GroupText',
                        )}
                     </InputGroup.Text>
                     <ToggleButtonGroup
                        type='radio'
                        name='quoteType'
                        value={state.quoteType}
                        className='my-0'
                        size='md'
                        role='group'
                        onChange={handleChange}
                     >
                        <ToggleButton id='full-quote' value={'full'} size='md'>
                           {getString('global.Full')}
                        </ToggleButton>
                        <ToggleButton
                           id='monthly-quote'
                           value={'monthly'}
                           size='md'
                        >
                           {getString('global.Monthly')}
                        </ToggleButton>
                        <ToggleButton
                           id='onetime-quote'
                           value={'onetime'}
                           size='md'
                        >
                           {getString('global.OneTime')}
                        </ToggleButton>
                     </ToggleButtonGroup>
                  </InputGroup>
               )}
               <div className={buttonContainerClass}>
                  <CloneEinButton buttonClass={'my-0 me-2'} buttonSize='md' />
                  {ShowDealdeskButton && (
                     <DealdeskModalButton
                        buttonClass={dealdeskMargin}
                        buttonSize='md'
                        HRImpPreDealdeskPrice={
                           state.hrImplementationCosts.totalPrice
                        }
                        BenAdminImpPreDealdeskPrice={
                           state.benefitsAdministrationImplementationCosts
                              .totalPrice
                        }
                        PayrollPreDealdeskPrice={
                           state.payrollImplementationTotalCosts.totalPrice
                        }
                        currencyObject={state.currencyObject}
                        disableHRISImp={
                           state.hrImplementationCosts?.appliedDiscounts?.filter(
                              (discount) =>
                                 !state?.ignoreHRISImplementationDealDeskDiscountList?.has(
                                    discount?.DiscountCode ?? '',
                                 ),
                           )?.length ?? 0 > 0
                        }
                        HRISImpSelected={
                           // Scenario 1: HRIS full only
                           (state.impType === 'full' &&
                              state.benAdminImpType === 'none') ||
                           // Scenario 2: HRIS full + Ben Admin
                           (state.impType === 'full' &&
                              state.benAdminImpType === 'full') ||
                           // Scenario 3: HRIS premier only
                           (state.impType === 'premier' &&
                              state.benAdminImpType === 'none') ||
                           // Scenario 4: HRIS premier + Ben Admin
                           (state.impType === 'premier' &&
                              state.benAdminImpType === 'full') ||
                           // Scenario 5: Ben Admin only
                           (state.impType === 'selfSetup' &&
                              state.benAdminImpType === 'full')
                        }
                        BenAdminImpSelected={state.benAdminImpType === 'full'}
                        disableQuickStart={
                           state.hrImplementationCosts?.appliedDiscounts?.filter(
                              (discount) =>
                                 !state?.ignoreQuickStartDealDeskDiscountList?.has(
                                    discount?.DiscountCode ?? '',
                                 ),
                           )?.length ?? 0 > 0
                        }
                        QuickStartSelected={
                           // Scenario 3: Quickstart only
                           (state.impType === 'quickstart' &&
                              state.benAdminImpType === 'none') ||
                           // Scenario 4: Quickstart + Ben Admin
                           (state.impType === 'quickstart' &&
                              state.benAdminImpType === 'full')
                        }
                        disablePayrollImp={
                           state.payrollImplementationTotalCosts?.appliedDiscounts?.filter(
                              (discount) =>
                                 !state?.ignorePayrollImplementationDealDeskDiscountList?.has(
                                    discount?.DiscountCode ?? '',
                                 ),
                           )?.length ?? 0 > 0
                        }
                        PayrollImpSelected={state.payrollImpType !== 'none'}
                        MRRSelected={state.monthlyTotal.totalPrice > 0}
                        HRISDisablingDiscountList={
                           state.hrImplementationCosts?.appliedDiscounts?.filter(
                              (discount) =>
                                 !state?.ignoreHRISImplementationDealDeskDiscountList?.has(
                                    discount?.DiscountCode,
                                 ),
                           ) ?? []
                        }
                        QuickstartDisablingDiscountList={
                           state.hrImplementationCosts?.appliedDiscounts?.filter(
                              (discount) =>
                                 !state?.ignoreQuickStartDealDeskDiscountList?.has(
                                    discount?.DiscountCode,
                                 ),
                           ) ?? []
                        }
                        payrollDisablingDiscountList={
                           state.payrollImplementationTotalCosts?.appliedDiscounts?.filter(
                              (discount) =>
                                 !state?.ignorePayrollImplementationDealDeskDiscountList?.has(
                                    discount?.DiscountCode,
                                 ),
                           ) ?? []
                        }
                        recordType={
                           state.accountStatus === 'Subscriber'
                              ? 'Expansion'
                              : 'New'
                        }
                        termLength={state.termLength}
                        opportunity_id={state.opportunity_id}
                     />
                  )}
                  <DealDeskDiscountCreatorButton
                     buttonClass={dealDeskDiscountMargin}
                     buttonSize='md'
                  />
                  {ShowBookQuoteButton && (
                     <BookQuoteButton
                        buttonClass={bookQuoteMargin}
                        buttonSize='md'
                     />
                  )}
               </div>
            </ButtonToolbar>
            <ButtonToolbar role='toolbar' className='mt-2 justify-content-end'>
               <Button
                  size='md'
                  className={clear_button_margin}
                  type='submit'
                  onClick={state.onClear}
               >
                  Clear
               </Button>
               {ShowSaveButton && (
                  <SaveButton
                     productPerformanceEECount={productPerformanceEECount}
                     setProductPerformanceEECount={setProductPerformanceEECount}
                     productTestAccount={productTestAccount}
                     setProductTestAccount={setProductTestAccount}
                     size='md'
                     className='my-0 me-5'
                  />
               )}
            </ButtonToolbar>
         </>
      )
   } else {
      return (
         <ButtonToolbar role='toolbar' className='mt-4 justify-content-end'>
            <Button
               size='md'
               className={clear_button_margin}
               type='submit'
               onClick={state.onClear}
            >
               Clear
            </Button>
            {ShowSaveButton && (
               <SaveButton
                  productPerformanceEECount={productPerformanceEECount}
                  setProductPerformanceEECount={setProductPerformanceEECount}
                  productTestAccount={productTestAccount}
                  setProductTestAccount={setProductTestAccount}
                  size='md'
                  className='ms-4 my-0 me-5'
               />
            )}
         </ButtonToolbar>
      )
   }
}
